import { render, staticRenderFns } from "./inviteLink.vue?vue&type=template&id=2c2bfb32"
import script from "./inviteLink.vue?vue&type=script&lang=js"
export * from "./inviteLink.vue?vue&type=script&lang=js"
import style0 from "./inviteLink.vue?vue&type=style&index=0&id=2c2bfb32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports